import { AxiosResponse } from 'axios'
import { stringify } from 'qs'
import { Dispatch, Action } from 'redux'
import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

type FetchMomentParams = {
  momentId: string
  fields: Record<string, any>
  include: string[]
  exposeUnscheduledMoments: boolean
}

type FetchMoment = (params: FetchMomentParams) => Promise<AxiosResponse>

export const fetchMoment: FetchMoment = ({
  momentId,
  fields,
  include = [],
  exposeUnscheduledMoments = false,
}) => {
  const queryString = stringify(
    {
      fields,
      include: include.join(','),
      expose: { unscheduled_moments: exposeUnscheduledMoments },
    },
    { arrayFormat: 'brackets' }
  )
  return HttpClient().get(`/moments/v2/${momentId}?${queryString}`)
}

export const include = [
  'asset_references',
  'asset_references.cover_asset_reference',
  'labels',
  'labels.label_set',
  'owner',
  'posts',
  'posts.service',
  'primary_asset_reference',
  'stories',
]

export const fields = {
  label: ['id', 'label_set', 'name'].join(','),
  moment: [
    'asset_references',
    'asset_references.cover_asset_reference',
    'brand',
    'day_segment',
    'is_ghost',
    'labels',
    'owner',
    'posts',
    'primary_asset_reference',
    'primary_story',
    'privacy_group',
    'scheduled_at',
    'scheduled_end_at',
    'stories',
    'title',
    'paired_block',
  ].join(','),
  service: [
    'asset_reference',
    'color',
    'icon_name',
    'is_active',
    'is_visible',
    'name',
    'system_name',
    'web_modules_channel',
  ].join(','),
  story: ['color', 'name', 'scheduled_end_at', 'scheduled_start_at'].join(','),
}

const getMoment =
  ({
    momentId,
    exposeUnscheduledMoments = false,
  }: {
    momentId: string
    exposeUnscheduledMoments: boolean
  }) =>
  (dispatch: Dispatch): Promise<Action<Dispatch>> =>
    fetchMoment({ momentId, fields, include, exposeUnscheduledMoments })
      .then((response) => dispatch(loadJsonApiEntities(response.data)))
      .catch((err) => {
        console.log(err)
        throw err
      })

export default getMoment
